// extracted by mini-css-extract-plugin
export default {"backNavigation":"styles_backNavigation__3VA4V","titleMargin":"styles_titleMargin__+9aGZ","title":"styles_title__1zuPV","headerRow":"styles_headerRow__uNJhk"};